module.exports = __webpack_public_path__ + "media/svg-new/cadeiraschool-153d8217.svg";